var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dev-container container",class:'dev-container-' + _vm.currentPage},[(_vm.currentPage === 'failOnPurpose')?_c('dev-failonpurpose-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }